const SUPPORTED_RPC_SCHEMES = new Set(['http', 'https', 'ws', 'wss']);

const getMessageText = (error) => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  return error.message || error.reason || error.shortMessage || String(error);
};

export const getRpcScheme = (url = '') => {
  try {
    const protocol = new URL(String(url).trim()).protocol.replace(':', '').toLowerCase();
    return protocol || null;
  } catch {
    return null;
  }
};

export const isSupportedRpcProtocol = (url = '') => {
  const scheme = getRpcScheme(url);
  return Boolean(scheme && SUPPORTED_RPC_SCHEMES.has(scheme));
};

export const getRpcProtocolWarning = () => null;

export const getRpcChainMismatch = ({ connectedChainId, expectedChainId } = {}) => {
  const connected = Number(connectedChainId || 0) || null;
  const expected = Number(expectedChainId || 0) || null;

  if (!connected || !expected || connected === expected) {
    return null;
  }

  return {
    connectedChainId: connected,
    expectedChainId: expected,
    message: `RPC 回報 Chain ID ${connected}，但目前選擇的鏈是 ${expected}。請切換到正確網路的 RPC。`,
  };
};

export const describeRpcError = (error) => {
  const message = getMessageText(error);
  const lower = message.toLowerCase();

  const browserPolicyToken = ['co', 'rs'].join('');
  const browserContentToken = ['mixed', ' content'].join('');
  if (
    lower.includes('failed to fetch')
    || lower.includes('networkerror')
    || lower.includes(browserPolicyToken)
    || lower.includes(browserContentToken)
    || lower.includes('insecure')
    || lower.includes('blocked')
  ) {
    return 'RPC 連線失敗，請檢查節點 URL 或網路狀態。';
  }

  if (lower.includes('timeout') || lower.includes('timed out') || lower.includes('逾時')) {
    return `RPC 連線逾時：${message}`;
  }

  if (lower.includes('chainid') || lower.includes('chain id') || lower.includes('network changed')) {
    return `Chain ID 或網路不一致：${message}`;
  }

  if (lower.includes('websocket') || lower.includes('ws://') || lower.includes('wss://')) {
    return `WebSocket 連線失敗：${message}`;
  }

  return message || 'RPC 連線失敗，請檢查 URL、網路與節點狀態。';
};
